/* MOJ Perfumes | Blog article helpers
   File: Assets/moj-blog-toc.js
   Why: (1) wraps listicle tables in a scroll container so mobile never scrolls
   the whole page sideways, (2) moves the server-rendered TOC (from
   snippets/moj-article-toc.liquid) to sit after the Article Summary per the
   article structure brief, drops the FAQ entry, and makes the TOC label a
   collapse toggle on mobile. Styles live in moj-blog-cards.css sections 4 and 5. */
(function () {
  'use strict';

  function wrapTables(article) {
    article.querySelectorAll('table.moj-listicle-table').forEach(function (tbl) {
      if (tbl.parentNode && tbl.parentNode.classList.contains('moj-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'moj-table-scroll';
      tbl.parentNode.insertBefore(wrap, tbl);
      wrap.appendChild(tbl);
    });
  }

  function placeToc(article) {
    var toc = article.querySelector('.moj-toc');
    if (!toc || toc.getAttribute('data-moj-placed')) return;
    toc.setAttribute('data-moj-placed', '1');

    // Why: FAQ questions are H3s the reader scans separately; the FAQ H2 adds noise to the TOC.
    toc.querySelectorAll('.moj-toc-item').forEach(function (li) {
      if (/frequently asked|faq/i.test(li.textContent)) li.parentNode.removeChild(li);
    });
    if (toc.querySelectorAll('.moj-toc-item').length < 3) { toc.parentNode.removeChild(toc); return; }

    // Why: brief order is Summary -> TOC -> body. Liquid prints the TOC first, so move it.
    var summary = article.querySelector('.moj-article-summary');
    if (summary && summary.parentNode) summary.parentNode.insertBefore(toc, summary.nextSibling);

    // Why: collapsed by default on phones so the intro is not pushed below the fold.
    var label = toc.querySelector('.moj-toc-label');
    if (label) {
      toc.classList.add('moj-toc--collapsible');
      label.setAttribute('role', 'button');
      label.setAttribute('tabindex', '0');
      label.setAttribute('aria-expanded', 'false');
      var toggle = function () {
        var open = toc.classList.toggle('is-open');
        label.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      label.addEventListener('click', toggle);
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    }
  }

  function wrapCardBodies(article) {
    // Why: the card's text pieces need one flex column (.moj-product-card-body)
    // to center vertically next to the photo. Wrapping here keeps article HTML
    // unchanged; the CSS also works (slightly less centered) without it.
    article.querySelectorAll('.moj-product-card').forEach(function (card) {
      if (card.querySelector('.moj-product-card-body')) return;
      var bodyEl = document.createElement('div');
      bodyEl.className = 'moj-product-card-body';
      var kids = Array.prototype.slice.call(card.children);
      kids.forEach(function (k) { if (k.tagName !== 'IMG') bodyEl.appendChild(k); });
      card.appendChild(bodyEl);
    });
  }

  function init() {
    var article = document.querySelector('.moj-article');
    if (!article) return;
    wrapTables(article);
    wrapCardBodies(article);
    placeToc(article);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Why: Shopify theme editor re-renders sections; run again after a section load.
  document.addEventListener('shopify:section:load', init);
})();

/* MOJ article tables — mobile label injection.
   Append to assets/moj-blog.js, or add as its own asset loaded after the
   article body renders.

   Why this exists: the stacked mobile layout needs each <td> to know its
   column name. Hand-writing data-label="Longevity" on every cell in every
   article is a guarantee that someone eventually forgets one and ships a
   card with an unlabelled value. This copies the labels from <thead> at
   runtime, so article HTML stays a plain table.

   Safe to run on pages with no tables. Runs once, no listeners left behind. */
(function () {
  function labelCells() {
    var tables = document.querySelectorAll('.moj-article table');

    for (var t = 0; t < tables.length; t++) {
      var headCells = tables[t].querySelectorAll('thead th');
      if (!headCells.length) continue;

      var labels = [];
      for (var h = 0; h < headCells.length; h++) {
        labels.push(headCells[h].textContent.trim());
      }

      var rows = tables[t].querySelectorAll('tbody tr');
      for (var r = 0; r < rows.length; r++) {
        var cells = rows[r].children;
        for (var c = 0; c < cells.length; c++) {
          /* Do not overwrite a label an editor set deliberately. */
          if (labels[c] && !cells[c].hasAttribute('data-label')) {
            cells[c].setAttribute('data-label', labels[c]);
          }
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelCells, { once: true });
  } else {
    labelCells();
  }
})();